((L, A) => {
	'use strict';

	/**
	 * Cast selection as Apt object
	 *
	 * @private
	 * @param {$|HTMLElement|String} sel
	 * @param {$|HTMLElement|String} [context=document]
	 */
	const Get = function(sel, context) {
		if (sel) {
			const els = Array.isArray(sel) ?
				sel : L.$toArray(L.$(sel, context));

			for (let i = 0; i < els.length; i++) {
				const el = els[i];

				if (el) {
					A.call(this, el);
				}
			}

			this.sel = sel;
		}
	};

	/**
	 * Create chainable Apt object from selection
	 *
	 * @param {$|HTMLElement|String} sel
	 * @param {$|HTMLElement|String} [context=document]
	 * @returns {Object}
	 */
	const $ = (sel, context) => {
		return new Get(sel, context);
	};

	if (Object.defineProperty) {
		Object.defineProperty(window, L._$, {
			get() {
				return $;
			},
			set() {
				// Prevent overriding
			}
		});
	} else {
		L._win[L._$] = $;
	}

	/**
	 * Create chainable Apt object from reference
	 *
	 * @param {String} ref
	 * @param {$|HTMLElement|String} [context=document]
	 * @returns {Object}
	 */
	L._win[L._$$] = (ref, context) => {
		if (typeof ref === 'string') {
			ref = '$' + ref.replace(/, */g, ',$');
		}

		return new Get(ref, context);
	};

	// Extend core with chain registration method
	L.fn.extend({
		/**
		 * Register a new chainable method
		 *
		 * @param {Object|String} a - method name or object
		 * @param {Function} b
		 */
		$chain(a, b) {
			if (typeof a === 'string') {
				$.fn[a] = b;
			} else {
				for (const key in a) {
					$.fn[key] = a[key];
				}
			}
		}
	});

	// Shortcut core methods from alias
	for (const key in L) {
		const val = L[key];

		$[key.replace(/^\$/, '')] = typeof val === 'function' ?
			val.bind(L) : val;
	}

	// Bind core chainable methods
	$.fn = Get.prototype = {
		_$: true,
		length: 0,

		/**
		 * Execute function for each object element
		 *
		 * @param {Function} fn
		 * @param {Object} [options]
		 * @param {Array} [options.args]
		 * @param {Object} [options.context=document]
		 * @param {Boolean} [options.reverse=false]
		 * @param {Array} [options.scope]
		 * @returns {Object}
		 */
		each(fn, options) {
			L.$each(this, fn, options);

			return this;
		},

		/**
		 * Translate object elements to a new array
		 *
		 * @param {Function} fn
		 * @param {Object} [options]
		 * @param {Array} [options.args]
		 * @param {Object} [options.scope]
		 * @returns {Array}
		 */
		map(fn, options) {
			return L.$map(this, fn, options);
		},

		/**
		 * Reverse the order of object elements
		 *
		 * @returns {$}
		 */
		reverse() {
			const copy = L.$copy(this);
			const count = this.length;

			let rem = count;

			for (let i = 0; i < count; i++) {
				rem--;

				this[i] = copy[rem];
			}

			return this;
		},

		/**
		 * Convert selection to standard array
		 *
		 * @returns {Object}
		 */
		toArray() {
			return Array.from(this);
		}
	};

	// Map shorthand registration method
	$.fn.extend = L.$chain;
})(Apt, [].push);